import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2E7D32',
        secondary: '#F5A623',
        accent: '#26C6DA',
        error: '#E57373',
        info: '#64B5F6',
        success: '#66BB6A',
        warning: '#FFB74D',
        off: '#ECEFF1'
      }
    }
  }
});
